export const MODAL_ID = "staff-job-revert-modal";

export const MODAL_COPY =
  'To confirm you wish to revert this job, please enter "REVERT" in the box below';
